import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="page">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <img 
            src={`${process.env.PUBLIC_URL}/icon.png`}
            alt="HeyGerman Logo" 
            style={{ 
              width: '60px', 
              height: '60px', 
              borderRadius: '50%',
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
              marginBottom: '20px'
            }} 
          />
        </div>
        <h1 style={{ textAlign: 'center', marginBottom: '40px', color: '#333' }}>
          Privacy Policy
        </h1>
        
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Information We Collect</h2>
            <div style={{ display: 'grid', gap: '20px' }}>
              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>👤 Personal Information</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  We collect personal information you provide when registering, including name, email address, 
                  phone number, and payment information for our German learning services.
                </p>
              </div>
              
              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>📊 Usage Data</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  We automatically collect information about your interactions with our platform, including 
                  learning progress, course completions, and platform usage statistics.
                </p>
              </div>

              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>🔐 Authentication Data</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  When you sign in with Google or other providers, we collect authentication tokens and 
                  basic profile information as permitted by your privacy settings.
                </p>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>How We Use Your Information</h2>
            <div style={{ padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
              <ul style={{ color: '#666', lineHeight: '1.6', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Service Delivery:</strong> To provide German learning courses and consultation services
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Account Management:</strong> To create and manage your user account and preferences
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Communication:</strong> To send important updates, course notifications, and support responses
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Improvement:</strong> To analyze usage patterns and improve our educational content
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Security:</strong> To protect against fraud, abuse, and security threats
                </li>
              </ul>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Data Security</h2>
            <div style={{ padding: '20px', backgroundColor: '#e8f4fd', borderRadius: '8px', border: '1px solid #bee5eb' }}>
              <h3 style={{ color: '#0c5460', marginBottom: '15px' }}>Security Measures</h3>
              <ul style={{ color: '#0c5460', lineHeight: '1.6', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>SSL encryption for all data transmissions</li>
                <li style={{ marginBottom: '8px' }}>Secure cloud storage with regular backups</li>
                <li style={{ marginBottom: '8px' }}>Regular security audits and monitoring</li>
                <li style={{ marginBottom: '8px' }}>Limited access controls for staff members</li>
                <li style={{ marginBottom: '8px' }}>Firebase authentication with industry-standard security</li>
              </ul>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Information Sharing</h2>
            <div style={{ padding: '20px', backgroundColor: '#d1ecf1', borderRadius: '8px', border: '1px solid #bee5eb' }}>
              <p style={{ color: '#0c5460', marginBottom: '15px', fontWeight: '500' }}>
                We do not sell, trade, or rent your personal information to third parties.
              </p>
              <h3 style={{ color: '#0c5460', marginBottom: '10px' }}>Limited Sharing Occurs Only For:</h3>
              <ul style={{ color: '#0c5460', lineHeight: '1.6', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>Payment processing through secure payment gateways</li>
                <li style={{ marginBottom: '8px' }}>Essential service providers (hosting, email delivery)</li>
                <li style={{ marginBottom: '8px' }}>Legal compliance when required by law</li>
                <li style={{ marginBottom: '8px' }}>Protection of our rights and safety</li>
              </ul>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Cookies and Analytics</h2>
            <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <h3 style={{ color: '#333', marginBottom: '15px' }}>We Use Cookies For:</h3>
              <ul style={{ color: '#666', lineHeight: '1.6', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>Maintaining your login session</li>
                <li style={{ marginBottom: '8px' }}>Remembering your preferences and settings</li>
                <li style={{ marginBottom: '8px' }}>Analytics to improve user experience</li>
                <li style={{ marginBottom: '8px' }}>Security and fraud prevention</li>
              </ul>
              <p style={{ color: '#666', marginTop: '15px', fontSize: '0.9rem' }}>
                You can control cookie settings through your browser, but some features may not work properly if disabled.
              </p>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Your Rights</h2>
            <div style={{ display: 'grid', gap: '15px' }}>
              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                <h3 style={{ color: '#333', marginBottom: '8px' }}>🔍 Access</h3>
                <p style={{ color: '#666', margin: 0, fontSize: '0.95rem' }}>
                  Request a copy of your personal data we have collected
                </p>
              </div>
              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                <h3 style={{ color: '#333', marginBottom: '8px' }}>✏️ Correction</h3>
                <p style={{ color: '#666', margin: 0, fontSize: '0.95rem' }}>
                  Update or correct any inaccurate personal information
                </p>
              </div>
              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                <h3 style={{ color: '#333', marginBottom: '8px' }}>🗑️ Deletion</h3>
                <p style={{ color: '#666', margin: 0, fontSize: '0.95rem' }}>
                  Request deletion of your personal data (subject to legal requirements)
                </p>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Data Retention</h2>
            <div style={{ padding: '20px', backgroundColor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffeaa7' }}>
              <p style={{ color: '#856404', margin: 0, lineHeight: '1.6' }}>
                We retain your personal information only as long as necessary to provide our services and 
                comply with legal obligations. Account data is typically retained for 3 years after account 
                closure, unless deletion is specifically requested or required by law.
              </p>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Contact Us</h2>
            <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <p style={{ color: '#666', marginBottom: '15px', lineHeight: '1.6' }}>
                For privacy-related questions or to exercise your rights, contact us:
              </p>
              <div style={{ display: 'grid', gap: '10px' }}>
                <p style={{ color: '#666', margin: 0 }}>
                  <strong>Email:</strong> pawankumar@babycode.org
                </p>
                <p style={{ color: '#666', margin: 0 }}>
                  <strong>Phone:</strong> +919030870876
                </p>
                <p style={{ color: '#666', margin: 0 }}>
                  <strong>Address:</strong> 91springboard, F948+W7, Kondapur, Laxmi Cyber City, 
                  Whitefields, HITEC City, Hyderabad, Telangana 500084
                </p>
              </div>
            </div>
          </div>

          <div style={{ padding: '20px', backgroundColor: '#28a745', borderRadius: '8px', textAlign: 'center' }}>
            <p style={{ color: 'white', margin: 0, fontSize: '1rem', lineHeight: '1.5' }}>
              <strong>Last Updated:</strong> September 25, 2025<br />
              We are committed to protecting your privacy and handling your data responsibly.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;